import { ColumnDef } from '@tanstack/react-table';
import { Calendar as CalendarIcon } from 'lucide-react';
import { DataTable } from '../../../../../components';
import { Card, CardContent, CardHeader, CardTitle } from '../../../../../components/ui/card';
import { AntecipacaoData } from '../types';

interface AntecipacaoTableProps {
  data: AntecipacaoData[];
  columns: ColumnDef<AntecipacaoData>[];
}

export function AntecipacaoTable({ data, columns }: AntecipacaoTableProps) {
  if (!data.length) {
    return (
      <Card className="bg-white border-[hsl(214,32%,91%)] shadow-sm">
        <CardContent className="py-8">
          <div className="text-center text-[hsl(215,16%,47%)]">
            <CalendarIcon className="mx-auto h-12 w-12 mb-4 opacity-50" />
            <p>Nenhuma solicitação de antecipação encontrada para esta data.</p>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-white border-[hsl(214,32%,91%)] shadow-sm">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-[hsl(210,50%,10%)]">
          <CalendarIcon className="h-5 w-5" />
          Solicitações de Antecipação
        </CardTitle>
      </CardHeader>
      <CardContent>
        <DataTable
          data={data}
          columns={columns}
          searchPlaceholder="Buscar por documento..."
          pageSize={100}
        />
      </CardContent>
    </Card>
  );
}
